import { PageContainer } from "@/src/components/atoms/";

import { type HomeArticleData } from "@/src/pages/consumer/HomePage/components/HomePageArticleBlock/HomePageArticleBlock";
import { HomePageContent } from "@/src/pages/consumer/HomePage/HomePageContent";

import { VehicleType } from "@/src/types/types";
import { type DealerLogoData } from "@/src/utils/dealerLogoUtils";

export interface HomePageProps {
  vehicleType: VehicleType;
  /** Build-time dealer logos from the route loader, so the HTML carries them. */
  dealerLogos: DealerLogoData;
  /** Build-time newest articles from the route loader, for the same reason. */
  initialArticles?: HomeArticleData;
}

const HomePage = ({
  vehicleType,
  dealerLogos,
  initialArticles
}: HomePageProps) => {
  return (
    <PageContainer sx={{ p: 0 }}>
      <HomePageContent
        vehicleType={vehicleType}
        dealerLogos={dealerLogos}
        initialArticles={initialArticles}
      />
    </PageContainer>
  );
};

export default HomePage;
